export const renderAccordionBorder = (color = '#7d411c', styles) => {
  return (
    <svg className={styles.event__accordion__border} xmlns="http://www.w3.org/2000/svg" width="300.086" height="6.638" viewBox="0 0 300.086 6.638">
      <g id="Group_2027" data-name="Group 2027" transform="translate(-19.845 -1801.407)">
        <path id="Path_2553" data-name="Path 2553" d="M19.845,1803.612l25.094.361,24.977-1.55,25.009-.4,9.37-.589,9.388.981,18.747-.528,18.752.317,18.749-.054,18.751-.6,18.75.161,18.756-.3,9.369.695,9.382-.3,24.989,1.382,25.008.312,24.992.9,0,.557-24.979,1.375-25.029-.46-24.982,1.7-9.375.23-9.391-1.256L207.435,1808l-18.756-1.154-18.748.594-18.751.392-18.753.191-18.754.019-9.377-.15-9.353-1.675-25.014.116-25-.594-24.909-1.231Z" fill={color}/>
      </g>
    </svg>
  );
}

export const renderArrow = (color = '#7d411c', className = '') => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="10.2" viewBox="0 0 17 10.2" className={className}>
      <path id="Path_1953" data-name="Path 1953" d="M133.134,3165.221l2.907,3.511,2.892,3.292,1.418,1.43,1.282,1.737-4.078.062-4.3-.157-4.3.326-4.317-.128,2.677-3.324,2.032-2.106,1.838-1.994Z" transform="translate(-124.634 -3165.221)" fill={color}/>
    </svg>
  );
}

export const getTimezoneName = () => {
  const today = new Date();
  const short = today.toLocaleDateString(undefined);
  const full = today.toLocaleDateString(undefined, { timeZoneName: 'short' });

  // Trying to remove date from the string in a locale-agnostic way
  const shortIndex = full.indexOf(short);
  if (shortIndex >= 0) {
    const trimmed = full.substring(0, shortIndex) + full.substring(shortIndex + short.length);
    
    // by this time `trimmed` should be the timezone's name with some punctuation -
    // trim it from both sides
    return trimmed.replace(/^[\s,.\-:;]+|[\s,.\-:;]+$/g, '');

  } else {
    // in some magic case when short representation of date is not present in the long one, just return the long one as a fallback, since it should contain the timezone's name
    return full;
  }
}

export const pluralWeek = (week) => {
  if (week > 1) return `${week} weeks`;
  else if (week === 1) return `${week} week`;
  return '';
}

export const pluralHour = (hour) => {
  if (hour > 1) return `${hour} hours`;
  else if (hour === 1) return `${hour} hour`;
  return '';
}

export const getDuration = (duration) => {
  const weeks = Math.round(duration / 168);
  const hours = duration - (weeks * 168);

  let dur = '';
  if (pluralWeek(weeks)) dur = dur + pluralWeek(weeks);
  if (pluralWeek(weeks) && pluralHour(hours)) dur = dur + " " + pluralHour(hours);
  else if (pluralHour(hours)) dur = pluralHour(hours);
  else dur = '0 hour';

  return dur;
}